/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
export class HistogramLayout {}
HistogramLayout.MIN_BAR_SIZE_WITH_GAPS = 5;
HistogramLayout.PERCENTAGE_BAR_SIZE = .95;
